import { HttpClient, URL_API } from "../../network";

class TokenizedCardServiceApi extends HttpClient {
  getListByUser = async (params: TParams & { user_id: string }) => {
    const { user_id, ...rest } = params;
    const data = await this.instance.get(
      URL_API.TOKENIZED_CARD.GET_LIST + `/${user_id}`,
      {
        params: rest,
      }
    );
    return data;
  };
}

export const TokenizedCardService = new TokenizedCardServiceApi();
